import { render, staticRenderFns } from "./my-setup.vue?vue&type=template&id=cf81251c&scoped=true&"
import script from "./my-setup.vue?vue&type=script&lang=js&"
export * from "./my-setup.vue?vue&type=script&lang=js&"
import style0 from "./my-setup.vue?vue&type=style&index=0&id=cf81251c&prod&lang=css&"
import style1 from "./my-setup.vue?vue&type=style&index=1&id=cf81251c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf81251c",
  null
  
)

export default component.exports